module.exports = __webpack_public_path__ + "static/media/add.dc106a78.png";